import {
  type Address,
  type SubscriptionAttributes,
  type Visitor,
} from '@bbkPricingPage/types/pricing-table-types';

export const EventKeys = {
  SET_VISITOR: 'pricify.hosted.page.setVisitor',
  SET_QUANTITY: 'pricify.hosted.page.setQuantity',
  SET_BILLING_ADDRESS: 'pricify.hosted.page.setBillingAddress',
  SET_SHIPPING_ADDRESS: 'pricify.hosted.page.setShippingAddress',
  SET_BUSINESS_ENTITY: 'pricify.hosted.page.setBusinessEntity',
  SET_CURRENCY: 'pricify.hosted.page.setCurrency',
  SET_PRICE_VARIANT: 'pricify.hosted.page.setPriceVariant',
  SET_SUBSCRIPTION_ATTRIBUTES: 'pricify.hosted.page.setSubscriptionAttributes',
  PAGE_LOAD: 'pricify.hosted.page.load',
  DIMENSION: 'pricify.hosted.page.dimension',
  SHOW_TOTAL_PRICE: 'pricify.hosted.page.showTotalPrice',
};

export const CbEventKeys = {
  SUCCESS: 'cb.success',
};

export type EventData = {
  source: 'pricify';
  type: EventType;
  payload: EventPayload;
};

export type EventOptions = {
  host: string;
  pricingPageKey?: string;
  sessionId?: string;
};

export type EventType = (typeof EventKeys)[keyof typeof EventKeys];

export type EventPayload =
  | SetVisitorEvent
  | SetQuantityEvent
  | SetBillingAddressEvent
  | SetShippingAddressEvent
  | SetBusinessEntityEvent
  | SetCurrencyEvent
  | SetPriceVariantEvent
  | SetSubscriptionAttributesEvent
  | CbSuccessEvent
  | PageLoadEvent
  | DimensionEvent
  | SetShowPriceEvent;

type BaseEvent = {
  siteId?: string;
  pricingPageId?: string;
  sessionId?: string;
};

export type SetVisitorEvent = Visitor & BaseEvent;

export type SetSubscriptionAttributesEvent = SubscriptionAttributes & BaseEvent;

export type SetQuantityEvent = {
  quantity?: number;
} & BaseEvent;

export type SetBusinessEntityEvent = {
  id?: string;
} & BaseEvent;

export type SetBillingAddressEvent = Address & BaseEvent;

export type SetShippingAddressEvent = Address & BaseEvent;

export type CbSuccessEvent = {
  value?: string;
  customerId?: string;
  redirectUrl?: string;
  data?: unknown;
} & BaseEvent;

export type SetCurrencyEvent = {
  currency?: string;
} & BaseEvent;

export type SetPriceVariantEvent = {
  id?: string;
} & BaseEvent;

export type PricingPageHostEventMetadata = {
  pricingPageKey: string;
  /** Pricing page origin (e.g. https://app.example.com) for parent postMessage targetOrigin */
  urlDomain: string;
  sessionId?: string;
  legacySiteId?: string;
  legacyPricingPageId?: string;
};

export type PageLoadEvent = {
  pricingPage?: unknown;
} & PricingPageHostEventMetadata;

export type DimensionEvent = {
  window: {
    height: number;
    width: number;
  };
  scroll: {
    height: number;
    width: number;
  };
} & PricingPageHostEventMetadata;

export type ShowPriceConfig = {
  prefix?: string;
  periodUnit?: string;
  period?: number;
  suffix?: string;
};

export type ShowPrice = {
  configs?: ShowPriceConfig[];
};

export type SetShowPriceEvent = ShowPrice & BaseEvent;
